import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { DateTime } from "luxon";
import TextareaAutosize from "react-textarea-autosize";

import Button from "../../../components/button";
import IconClose from "../../../components/icons/close";
import Localization from "../../../localization";
import Image from "../../../components/image";
import { updateUserMe } from "../../../redux/actions/me";
import { getMe } from "../../../redux/selectors/me";
import { getUrl } from "../../../utils/helper";

class ProfileEdit extends Component {
    constructor(props) {
        super(props);

        this._handleSubmit = this._handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isUpdating && prevProps.isUpdating) {
            this.props.history.replace(getUrl("account/profile"));
        }
    }

    _handleSubmit(values) {
        let data = values;
        data.phone = "" + values.phone;
        if (values.nif) {
            data.nif = "" + values.nif;
        }
        this.props.updateUserMe(data);
    }

    _renderButton(input, name, values, style, wrapperStyle) {
        const textSelected =
            "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-white";
        const textUnselected =
            "font-bold text-17 z-10 transition hover-hover:group-hover:text-white hover-hover:group-hover:opacity-100 text-black opacity-20";

        const bgSelected = "bg-blue";
        const bgUnselected = "bg-grey";

        const borderSelected = "border-blue";
        const borderUnselected = "border-black border-opacity-20";

        return (
            <Button
                text={name}
                textStyle={
                    values[input] === name ? textSelected : textUnselected
                }
                backgroundColor={
                    values[input] === name ? bgSelected : bgUnselected
                }
                borderColor={
                    values[input] === name ? borderSelected : borderUnselected
                }
                style={style}
                wrapperStyle={wrapperStyle}
                onClick={() => {
                    this._form.setFieldValue(input, name);
                }}
            />
        );
    }

    render() {
        const { user, locale, isUpdating } = this.props;

        let initialValues = {
            name: user.name,
            email: user.email,
            type: user.type || "",
            gender: user.gender || "",
            birthday: user.birthday
                ? DateTime.fromISO(user.birthday).toISODate()
                : "",
            nationality: user.nationality || "",
            address: user.address || "",
            country: user.country || "",
            district: user.district || "",
            city: user.city || "",
            postal_code: user.postal_code || "",
            nif: user.nif || "",
            phone: user.phone || "",
            website_url: user.website_url || "",
            bio: user.bio || "",
        };

        let editSchema = Yup.object().shape({
            name: Yup.string().required(
                Localization[locale].validation.required
            ),
            email: Yup.string().required(
                Localization[locale].validation.required
            ),
            type: Yup.string().required(
                Localization[locale].validation.required
            ),
            gender: Yup.string().required(
                Localization[locale].validation.required
            ),
            birthday: Yup.date()
                .typeError(Localization[locale].validation.date)
                .required(Localization[locale].validation.required),
            nationality: Yup.string().required(
                Localization[locale].validation.required
            ),
            address: Yup.string().required(
                Localization[locale].validation.required
            ),
            country: Yup.string().required(
                Localization[locale].validation.required
            ),
            district: Yup.string().required(
                Localization[locale].validation.required
            ),
            city: Yup.string().required(
                Localization[locale].validation.required
            ),
            postal_code: Yup.string().required(
                Localization[locale].validation.required
            ),
            phone: Yup.string().required(
                Localization[locale].validation.required
            ),
            bio: Yup.string().required(
                Localization[locale].validation.required
            ),
        });

        return (
            <Formik
                initialValues={initialValues}
                validationSchema={editSchema}
                onSubmit={this._handleSubmit}
                innerRef={(ref) => (this._form = ref)}
            >
                {({ handleSubmit, handleChange, values }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="flex flex-col mb-16">
                            <div className="flex relative">
                                <p className="text-30 font-judge font-bold flex-1">
                                    {Localization[locale].account.edit_title}
                                </p>
                                <div className="xl:hidden absolute right-0 top-0">
                                    <Button
                                        icon={
                                            <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                        }
                                        to={getUrl("account/profile")}
                                        style={"w-50 xl:w-70"}
                                    />
                                </div>
                                <div className="hidden xl:block absolute right-0 top-0">
                                    <Button
                                        submit
                                        text={
                                            Localization[locale].account
                                                .button_save
                                        }
                                        textStyle={
                                            "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                                        }
                                        style="w-150 z-10"
                                        loading={isUpdating}
                                    />
                                </div>
                            </div>
                            <div className="grid xl:grid-cols-2 gap-16 mt-40">
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.name}
                                    </p>
                                    <Field
                                        type="text"
                                        name="name"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="name" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.email}
                                    </p>
                                    <Field
                                        type="email"
                                        name="email"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="email" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.type}
                                    </p>
                                    <Field
                                        type="text"
                                        name="type"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="type" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.password}
                                    </p>
                                    <Field
                                        type="password"
                                        name="password"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="password" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold">
                                        {Localization[locale].account.gender}
                                    </p>
                                    <div className="flex flex-col xl:flex-row flex-wrap mt-26 xl:-mx-8">
                                        {this._renderButton(
                                            "gender",
                                            Localization[locale].register
                                                .step_3_gender_op_1,
                                            values,
                                            "mb-8 xl:m-8",
                                            "px-20"
                                        )}
                                        {this._renderButton(
                                            "gender",
                                            Localization[locale].register
                                                .step_3_gender_op_2,
                                            values,
                                            "mb-8 xl:m-8",
                                            "px-20"
                                        )}
                                        {this._renderButton(
                                            "gender",
                                            Localization[locale].register
                                                .step_3_gender_op_3,
                                            values,
                                            "mb-8 xl:m-8",
                                            "px-20"
                                        )}
                                        {this._renderButton(
                                            "gender",
                                            Localization[locale].register
                                                .step_3_gender_op_4,
                                            values,
                                            "mb-8 xl:m-8",
                                            "px-20"
                                        )}
                                    </div>
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="gender" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.birthday}
                                    </p>
                                    <Field
                                        type="date"
                                        name="birthday"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="birthday" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {
                                            Localization[locale].account
                                                .nationality
                                        }
                                    </p>
                                    <Field
                                        type="text"
                                        name="nationality"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="nationality" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.address}
                                    </p>
                                    <Field
                                        type="text"
                                        name="address"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="address" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {
                                            Localization[locale].account
                                                .postal_code
                                        }
                                    </p>
                                    <Field
                                        type="text"
                                        name="postal_code"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="postal_code" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.city}
                                    </p>
                                    <Field
                                        type="text"
                                        name="city"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="city" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.district}
                                    </p>
                                    <Field
                                        type="text"
                                        name="district"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="district" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.country}
                                    </p>
                                    <Field
                                        type="text"
                                        name="country"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="country" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.vat}
                                    </p>
                                    <Field
                                        type="number"
                                        name="nif"
                                        maxLength={9}
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="nif" />
                                    </p>
                                </div>
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.phone}
                                    </p>
                                    <Field
                                        type="number"
                                        name="phone"
                                        maxLength={9}
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                    />
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="phone" />
                                    </p>
                                </div>
                            </div>
                            <div className="grid xl:grid-cols-2 xl:mt-26">
                                <div className="mb-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.website}
                                    </p>
                                    <Field
                                        type="text"
                                        name="website_url"
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                        placeholder={
                                            Localization[locale].register
                                                .step_9_website_placeholder
                                        }
                                    />
                                </div>
                                <div>
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.biography}
                                    </p>
                                    <TextareaAutosize
                                        value={values.bio}
                                        cacheMeasurements
                                        type="text"
                                        name="bio"
                                        maxLength={1000}
                                        className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full font-brown"
                                        placeholder={
                                            Localization[locale].register
                                                .step_9_bio_placeholder
                                        }
                                        onChange={handleChange}
                                    />
                                    <p className="text-orange text-12 mt-6">
                                        {
                                            Localization[locale].register
                                                .step_9_bio_max
                                        }
                                    </p>
                                    <p className="text-red text-12 mt-6">
                                        <ErrorMessage name="bio" />
                                    </p>
                                </div>
                            </div>
                            {user.photo && (
                                <div className="mt-26">
                                    <p className="font-bold mb-6">
                                        {Localization[locale].account.photo}
                                    </p>
                                    <div className="w-200">
                                        <Image
                                            alt={user.name}
                                            url={user.photo.url}
                                            aspectRatio="aspect-ratio-square"
                                            width={196}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="fixed bg-grey p-16 bottom-0 z-10 left-0 right-0 xl:hidden">
                            <Button
                                submit
                                text={Localization[locale].account.button_save}
                                textStyle={
                                    "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                                }
                                style="w-full"
                                loading={isUpdating}
                            />
                        </div>
                    </form>
                )}
            </Formik>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
    isUpdating: state.me.isUpdating,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            updateUserMe,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEdit);
